import type { RefObject } from 'react'
import { useEffect } from 'react'

export const useOutsideClick = (
  ref: RefObject<HTMLElement>,
  active: boolean,
  callback: () => void,
  type: 'mousedown' | 'click',
) => {
  const handleClick = (e: MouseEvent | TouchEvent) =>
    active &&
    ref.current &&
    !ref.current.contains(e.target as Node) &&
    callback()
  useEffect(() => {
    document.addEventListener(type || 'click', handleClick, { passive: true })
    return () => document.removeEventListener(type || 'click', handleClick)
  })
}

export default useOutsideClick
